import React, { useEffect, useState } from 'react'
import Network from '../utils/Network'
import ReactPaginate from 'react-paginate'
import ItemCard from './ItemCard';
import { ItemStateEnum, ItemStateType, PlayerItemType } from '../types/items';
import Dialog from './Dialog';
import useToast from '../hooks/useToast';
import { CheckIcon, ClegIcon } from './Icons';
import CircularProgress from './CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { motion } from 'framer-motion'
import Button from './Button';
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';
import { Badge } from 'react-bootstrap';
import { useAppTranslation } from '../i18n/useAppTranslation';

type Props = {}

type SellDialogType = {
    open: boolean;
    price: number | undefined;
    item: PlayerItemType | undefined
}
type MergeDialogType = {
    open: boolean;
    item: PlayerItemType | undefined
    destItem?: PlayerItemType | undefined
}


const ItemSection = (props: Props) => {
    const { t } = useAppTranslation(["barracks", "common"]);
    const [items, setItems] = useState<PlayerItemType[] | undefined>()
    const [allItems, setAllItems] = useState<PlayerItemType[] | undefined>()
    const axios = new Network()
    const [paginations, setPaginations] = useState({ total: 1, page: 1 })
    const [sellDialog, setSellDialog] = useState<SellDialogType>({ open: false, price: undefined, item: undefined })
    const [mergeDialog, setMergeDialog] = useState<MergeDialogType>({ open: false, item: undefined, destItem: undefined })
    const [actionLoading, setActionLoading] = useState(false);
    const [fetchLoading, setFetchLoading] = useState(false);
    const [fetchAllLoading, setFetchAllLoading] = useState(false);
    const [confimDialog, setConfirmDialog] = useState<any>({
        open: false,
        submit: null,
        title: '',
        msg: ''
    })

    const openToast = useToast()

    const handleSellItem = async () => {
        setActionLoading(true)
        const response = await axios.CallApi({
            url: `/playeritem/${sellDialog.item?.id}/sell?price=${sellDialog.price}`,
            method: 'get'
        })
        openToast(response)
        if (response.ok) {
            handleGetItems(paginations.page)
            setSellDialog((prev) => ({ ...prev, open: false }))
        }
        setActionLoading(false);
    }
    const unuseItem = async (id: number) => {
        setActionLoading(true)
        const response = await axios.CallApi({
            url: `/playeritem/${id}/unuse`,
            method: 'delete'
        })
        openToast(response)
        if (response.ok) {
            handleGetItems(paginations.page)
            setConfirmDialog((prev) => ({ ...prev, open: false }))
        }
        setActionLoading(false);
    }
    const cancelSell = async (id: number) => {
        setActionLoading(true)
        const response = await axios.CallApi({
            url: `/market/my-order/${id}`,
            method: 'delete'
        })
        openToast(response)
        if (response.ok) {
            handleGetItems(paginations.page)
            setConfirmDialog((prev) => ({ ...prev, open: false }))
        }
        setActionLoading(false);
    }
    const handleMergeItem = React.useCallback(async () => {
        if (!mergeDialog.destItem) return openToast({ ok: false, message: t("barracks:itemsTab.pleaseSelectItem") })
        setActionLoading(true)
        const response = await axios.CallApi({
            url: `/playeritem/${mergeDialog.item?.id}/merge/${mergeDialog.destItem.id}`,
            method: 'get'
        })
        openToast(response)
        if (response.ok) {
            handleGetItems(paginations.page)
            setMergeDialog((prev) => ({ ...prev, open: false, destItem: undefined }))
        }
        setActionLoading(false);
    }, [mergeDialog, t])

    const closeMergeDialog = () => setMergeDialog(prev => ({ ...prev, open: false }));

    const handleSelectItem = (item: PlayerItemType) => setMergeDialog(prev => ({ ...prev, destItem: item }))

    const filteredItems = React.useMemo(() => allItems?.filter((item) => item.itemId === mergeDialog.item?.itemId
        && item.level === mergeDialog.item?.level
        && item.id !== mergeDialog.item?.id), [allItems, mergeDialog])

    const handleGetAllItems = async () => {
        setFetchAllLoading(true)
        const response = await axios.CallApi({
            url: `/playeritem?page=1&count=1000`,
            method: 'get'
        })
        if (response.ok) {
            setAllItems(response.data?.data)
        }
        setFetchAllLoading(false)
    }


    const handleGetItems = async (page: number) => {
        setFetchLoading(true)
        const response = await axios.CallApi({
            url: `/playeritem?page=${page}&count=20`,
            method: 'get'
        })
        if (response.ok) {
            setItems(response.data?.data)
            setPaginations({ total: Math.ceil(response.data?.totalCount / 20), page })
        }
        setFetchLoading(false)
    }

    useEffect(() => {
        if (mergeDialog.open && !allItems) {
            handleGetAllItems()
        }
    }, [mergeDialog])

    useEffect(() => {
        handleGetItems(1)
    }, [])

    return (
        <div>
            <div className='row pt-5'>
                {fetchLoading && [1, 2, 3, 4, 5, 6, 7, 8].map((item) =>
                    <motion.div initial={isMobile ? {} : { opacity: 0 }} animate={{ y: 0, opacity: 1 }}
                        transition={{
                            delay: item * 0.04
                        }}
                        className='col-12 mt-2 col-md-6 col-lg-4 col-xl-3'>
                        <ItemCard
                            loading
                        />
                    </motion.div>
                )}
                {!fetchLoading && items?.length === 0 && <motion.div initial={isMobile ? {} : { opacity: 0 }} animate={{ y: 0, opacity: 1 }} className='bg-paper text-center mb-5 rounded py-2 px-3'>

                    {t("barracks:itemsTab.empty")} <Link to="/marketplace?type=5">
                        {t("barracks:itemsTab.marketplace")}
                    </Link>
                </motion.div>}
                {!fetchLoading && items?.map((item, key) => (
                    <motion.div initial={isMobile ? {} : { y: 200, opacity: 0 }}
                        exit={{ y: 200, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{
                            delay: key * 0.04
                        }}
                        className='col-12 mt-2 col-md-6 col-lg-4 col-xl-3'>
                        <ItemCard
                            onUnuse={(item) => setConfirmDialog({
                                open: true,
                                msg: t("barracks:itemsTab.confirmDetach"),
                                submit: () => unuseItem(item.id),
                                title: t("common:actions.confirm")
                            })
                            }
                            onCancel={(item) => setConfirmDialog({
                                open: true,
                                msg: t("barracks:itemsTab.confirmCancelOrder"),
                                submit: () => cancelSell(item?.sellOrder?.id!),
                                title: t("common:actions.confirm")
                            })} onMerge={(item) => setMergeDialog({ open: true, item })} onSell={(item) => setSellDialog({ open: true, price: undefined, item })} refreshList={() => handleGetItems(1)} data={item} />
                    </motion.div>
                ))}
            </div>

            <Dialog loading={actionLoading} open={sellDialog.open} closeLabel={t("common:actions.cancel")} onSubmit={handleSellItem} submitLabel={t("common:actions.sell")} title={t("barracks:itemsTab.sellItem")} onClose={() => setSellDialog(prev => ({ ...prev, open: false }))} >
                <div className='p-relative' style={{ zIndex: 200 }}>
                    <div className='rounded fs-med bg-2 my-2 p-2'>
                        <img src={sellDialog.item?.image} width={70} />  <span>
                            {t("barracks:itemsTab.selling")} <b>{sellDialog.item?.item?.name}</b> {t("common:labels.level")} {sellDialog.item?.level}     </span>
                    </div>
                    <p className='dark-yellow'>
                        {t("barracks:itemsTab.itemPrice")} (<ClegIcon width={25} height={25} /> {t("barracks:stats.cleg")}):
                    </p>
                    <input
                        onKeyPress={(event) => { if (!/[0-9\.]/.test(event.key)) { event.preventDefault(); } }}
                        onChange={(e) => setSellDialog(prev => ({ ...prev, price: +e.target.value! }))}
                        placeholder={t("barracks:itemsTab.enterPrice")}
                        type="text"
                        value={sellDialog.price}
                        style={{ marginBottom: -25 }}
                        className='w-100 form-control form-input dark-yellow'
                    />
                </div>
            </Dialog>

            <Dialog disableSubmit={!mergeDialog.destItem} loading={actionLoading} onSubmit={() => handleMergeItem()} submitLabel={t("common:actions.merge")} closeLabel={t("common:actions.cancel")} open={mergeDialog.open} onClose={closeMergeDialog} title={t("barracks:itemsTab.mergeItems")}>
                <div style={{ marginBottom: -40 }}>
                    <PerfectScrollbar style={{ maxHeight: 300 }}>
                        <div className='d-flex align-items-center flex-column gap-2'>
                            {fetchAllLoading && <CircularProgress />}
                            {filteredItems?.length === 0 && <div className='rounded py-3 fs-med px-2 bg-2 '>
                                {t("barracks:itemsTab.noMatchingItems")} <b>
                                    {mergeDialog.item?.item?.name} {mergeDialog.item?.level}
                                </b>
                            </div>}
                            {filteredItems?.map((item) => {
                                const isSelected = item.id === mergeDialog.destItem?.id
                                return <div className={`rounded w-100 gap-2 p-1 bg-2 d-flex align-items-center transition ${isSelected && 'bg-brown'}`}>
                                    <div>
                                        <img src={item.image} width={70} />
                                    </div>
                                    <div >
                                        {item.item.name}
                                        {(item.state === ItemStateEnum.InUse || item.state === ItemStateEnum.ForSale) && <Badge className='ms-1' bg={"danger"}>
                                            {t(`barracks:states.${ItemStateType[item.state]}`)}
                                        </Badge>}
                                    </div>
                                    <div className='flex-grow-1' />
                                    {isSelected ?
                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            className='me-2'
                                        >
                                            <CheckIcon width={28} height={25} /> {t("barracks:itemsTab.selected")}
                                        </motion.div>
                                        :
                                        <Button disabled={item.state === ItemStateEnum.InUse || item.state === ItemStateEnum.ForSale} onClick={() => handleSelectItem(item)} variant='primary'>
                                            {t("barracks:dialogs.merge.select")}
                                        </Button>}

                                </div>
                            })}
                        </div>
                    </PerfectScrollbar>
                </div>

            </Dialog>

            <ReactPaginate
                className='pagination mt-2 justify-content-center'
                activeClassName='active-pg'
                pageClassName='page-item'
                pageLinkClassName='page-link'
                breakClassName='page-item'
                nextClassName='page-item'
                nextLinkClassName='page-link'
                breakLinkClassName='page-link'
                previousLinkClassName='page-link'
                previousClassName='page-item'
                previousLabel="<"
                nextLabel=">"
                breakLabel="..."
                onPageChange={(e) => handleGetItems(e.selected + 1)}
                pageRangeDisplayed={3}
                pageCount={paginations.total}
            // renderOnZeroPageCount={null}
            />

            <Dialog loading={actionLoading} title={confimDialog?.title}
                closeLabel={t("common:actions.no")} submitLabel={t("common:actions.yes")}
                onSubmit={confimDialog?.submit} open={confimDialog?.open}
                onClose={() => setConfirmDialog(prev => ({ ...prev, open: false }))}>
                {confimDialog?.msg}
            </Dialog>


        </div>
    )
}

export default ItemSection
